import React from 'react'
import { Link } from 'react-router-dom';

export default function RecipesShort(props) {
 
  const items = props.data;

  return (
    <>
      {items.map((item, index) => (
         <div className='col-xl-6 col-lg-4 col-sm-6 col-xs-12 dynamicImageSize' key={index}>
           <div>
            <Link to={`/recipe/${item.id}`}>
             <div className='image-container imageHeight'>
              <img className="imageResize" src={item.image} alt={`Item ${index + 1}`} />
             </div>
            </Link>
          <div className='content container-fluid'>
            <Link to={`/recipes/${item.type}`} style={{textDecoration: 'none'}}>
            <div className='type smallType'>{item.type}</div>
            </Link>
            <Link to={`/recipe/${item.id}`} className='anchorTag' style={{lineHeight: '1.5'}}>
            <div className='title smallTitle'>{item.title}</div>
            </Link>
            <div className='description smallDescription'>{item.description}</div>
            <hr />
            <div className='time-difficulty smallTimeDifficulty'>
              <i className="fa-regular fa-clock"></i>
              <span className='time smallTime'>{item.time} minutes</span>
              <i className="fa-regular fa-heart"></i>
              <span className='difficulty smallDifficulty'>{item.difficulty} hp</span>
            </div>
          </div>
        </div>
    </div>
      ))}
    </>
  )
}
